import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import vuetify from './plugins/vuetify';
import i18n from './plugins/i18n';
import MomentPlugin from './plugins/moment';
import VuetifyMoney from 'vuetify-money';

Vue.config.productionTip = false;

// init i18n with the locale into the store
i18n.locale = store.getters['locale/locale'];

Vue.use(MomentPlugin, { store });
Vue.use(VuetifyMoney);

// init common data
export function initCommonData(store) {
  store.dispatch('company/initCompaniesAvailable');
  store.dispatch('role/initRolesAvailable');
}

new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: h => h(App)
}).$mount('#app');
